export enum LicensePlateTypes {
    LICENSE_PLATE_CAR_STANDARD = "LICENSE_PLATE_CAR_STANDARD",
    LICENSE_PLATE_CAR_PERSONALIZED = "LICENSE_PLATE_CAR_PERSONALIZED"
}

export type LicensePlateConfiguration = {
    chosenLicensePlateText: string;
    chosenLicensePlateType: LicensePlateTypes;
};

export type LicensePlateSubmitModel = {
    chosenLicensePlateText: string;
    chosenLicensePlateType: LicensePlateTypes;
};
